module.exports = __webpack_public_path__ + "img/201128-3.98b51b27.jpeg";